import { Modal } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";
import { baixarCertificado } from "./zebraBrowserPrint.service";

const isMac = navigator.platform.toUpperCase().includes("MAC");

interface QzTraySetupModalProps {
  show: boolean;
  onFechar: () => void;
}

export function QzTraySetupModal({ show, onFechar }: QzTraySetupModalProps) {
  return (
    <Modal show={show} onHide={onFechar} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Configurar Impressora (QZ Tray)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-4">
          Para imprimir etiquetas Zebra sem popup de permissão, siga os passos abaixo <strong>uma única vez</strong> em cada computador.
        </p>

        <div className="d-flex flex-column gap-3">
          <div className="border rounded p-3">
            <strong>Passo 1 — Instalar o QZ Tray</strong>
            <p className="mb-2 mt-1 text-muted" style={{ fontSize: "0.9rem" }}>
              Se ainda não tiver instalado, baixe e instale o QZ Tray. Após instalar, ele aparece na bandeja do sistema (ícone na barra inferior).
            </p>
            <a
              href="https://qz.io/download/"
              target="_blank"
              rel="noreferrer"
            >
              <PrimaryButton outline variante="primary" buttonWidth="md" buttonWidthTipo="px">
                Baixar QZ Tray
              </PrimaryButton>
            </a>
          </div>

          <div className="border rounded p-3">
            <strong>Passo 2 — Baixar o certificado</strong>
            <p className="mb-2 mt-1 text-muted" style={{ fontSize: "0.9rem" }}>
              Baixe o certificado de segurança desta aplicação.
            </p>
            <PrimaryButton outline variante="primary" buttonWidth="md" buttonWidthTipo="px" onClick={baixarCertificado}>
              Baixar certificado (.pem)
            </PrimaryButton>
          </div>

          <div className="border rounded p-3">
            <strong>Passo 3 — Adicionar o certificado no QZ Tray</strong>
            {isMac ? (
              <ol className="mt-1 mb-0 text-muted" style={{ fontSize: "0.9rem" }}>
                <li>Clique no ícone do <strong>QZ Tray</strong> na barra de menu (canto superior direito da tela)</li>
                <li>Clique em <strong>Advanced</strong></li>
                <li>Clique em <strong>Site Manager</strong></li>
                <li>Clique em <strong>Add Certificate</strong></li>
                <li>Selecione o arquivo <code>certificado-impressora.pem</code> baixado no passo anterior</li>
                <li>Clique em <strong>Save</strong></li>
              </ol>
            ) : (
              <ol className="mt-1 mb-0 text-muted" style={{ fontSize: "0.9rem" }}>
                <li>Na barra de tarefas do Windows (canto inferior direito), clique na seta <strong>"^"</strong> para ver os ícones ocultos</li>
                <li>Clique com botão direito no ícone do <strong>QZ Tray</strong></li>
                <li>Clique em <strong>Advanced</strong></li>
                <li>Clique em <strong>Site Manager</strong></li>
                <li>Clique em <strong>Add Certificate</strong></li>
                <li>Selecione o arquivo <code>certificado-impressora.pem</code> baixado no passo anterior</li>
                <li>Clique em <strong>Save</strong></li>
              </ol>
            )}
          </div>

          <div className="border rounded p-3">
            <strong>Passo 4 — Testar</strong>
            <p className="mb-0 mt-1 text-muted" style={{ fontSize: "0.9rem" }}>
              Feche este guia, clique em <strong>Tentar novamente</strong> e marque <strong>"Remember"</strong> no popup do QZ Tray. A partir de agora não pedirá mais permissão neste computador.
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton variante="primary" buttonWidth="md" buttonWidthTipo="px" onClick={onFechar}>
          Fechar
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  );
}
